import { thirdPartyEndpoints } from '../3rdParty';
import { activitiesEndpoints } from '../activity/activityEndpoints';
import { activityConfigurationEndpoints } from '../activityConfiguration/activityConfigurationEndpoints';
import { additionalServicesEndpoints } from '../additionalServices/additionalServicesEndpoints';
import { alertsEndpoints } from '../alerts/alertsEndpoints';
import { assemblyEndpoints } from '../assembly/assemblyEndpoints';
import { authEndpoints } from '../auth/authEndpoints';
import { avlScopeEndpoints } from '../avlScope/avlScopeEndpoints';
import { azureEndpoints } from '../azure/azureEndpoints';
import { bomExportTemplateEndpoints } from '../bomExportTemplate';
import { bomImporterEndpoints } from '../bomImporter/bomImporterEndpoints';
import { bomItemEndpoints } from '../bomItem/bomItemEndpoints';
import { calculationEndpoints } from '../calculation/calculationEndpoints';
import { calculationTemplatesEndpoints } from '../calculationTemplates/calculationTemplatesEndpoints';
import { commentsEndpoints } from '../comments/commentsEndpoints';
import { componentEndpoints } from '../component/componentEndpoints';
import { contributorEndpoints } from '../contributors/contributorEndpoints';
import { costedBomExportTemplateEndpoints } from '../costedBomExportTemplate';
import { customAttributesEndpoints } from '../customAttributes/customAttributesEndpoints';
import { customerEndpoints } from '../customer/customerEndpoints';
import { customerPortalSettingsEndpoints } from '../customerPortalSettings/customerPortalSettingsEndpoints';
import { customPartCategoryEndpoints } from '../customPartSpecification/customPartCategoryEndpoints';
import { dashboardEndpoints } from '../dashboard/dashboardEndpoints';
import { demandEndpoints } from '../demand/demandEndpoints';
import { demandGroupEndpoints } from '../demandGroup/demandGroupEndpoints';
import { demandScenarioEndpoints } from '../demandScenario/demandScenarioEndpoints';
import { designItemEndpoints } from '../designItem/designItemEndpoints';
import { driversEndpoints } from '../driver/driversEndpoints';
import { emailTemplateEndpoints } from '../emailTemplates/emailTemplateEndpoints';
import { expenseConfigurationEndpoints } from '../expenseConfiguration/expenseConfigurationEndpoints';
import { expensesEndpoints } from '../expenses/expensesEndpoints';
import { exportEndpoints } from '../export/exportEndpoints';
import { filesEndpoints } from '../files/filesEndpoints';
import { flexibleCalculationEndpoints } from '../flexibleCalculation/flexibleCalculationEndpoints';
import { formulaEndpoints } from '../formula/formulaEndpoints';
import { gatewayEndpoints } from '../gateway/gatewayEndpoints';
import { internalPartNumberEndpoints } from '../internalPartNumber/internalPartNumberEndpoint';
import { llmUsageEndpoints } from '../llmUsage/llmUsageEndpoints';
import { machineTokenEndpoints } from '../machineToken/machineTokenEndpoints';
import { manufacturerEndpoints } from '../manufacturer/manufacturerEndpoints';
import { manufacturingAssemblyDetailsEndpoints } from '../manufacturingAssemblyDetails/manufacturingAssemblyDetailsEndpoints';
import { manufacturingSourcingCacheEndpoints } from '../manufacturingCache/manufacturingSourcingCacheEndpoints';
import { manufacturingKvEndpoints } from '../manufacturingKv/manufacturingKvEndpoints';
import { manufacturingScenarioEndpoints } from '../manufacturingScenarios/manufacturingScenarioEndpoints';
import { manufacturingScenarioTemplatesEndpoints } from '../manufacturingScenarioTemplates/manufacturingScenarioTemplates';
import { negotiationEndpoints } from '../negotiation/negotiationEndpoints';
import { offerEndpoints } from '../offer/offerEndpoints';
import { offerImportContextEndpoints } from '../offerImportContext/offerImportContextEndpoints';
import { orderEndpoints } from '../orders';
import { organizationSettingsEndpoints } from '../organizationSettings/organizationSettingsEndpoints';
import { partEndpoints } from '../part/partEndpoints';
import { pcbEndpoints } from '../pcb/pcbEndpoints';
import { pcbFilesEndpoints } from '../pcb/pcbFilesEndpoints';
import { pcbPanelPreferenceEndpoints } from '../pcb/pcbPanelPreferenceEndpoints';
import { pcbShareEndpoints } from '../pcb/pcbShareEndpoints';
import { pcbSpecificationTemplateEndpoints } from '../pcb/pcbSpecificationTemplateEndpoints';
import { pcbQuotationEndpoints } from '../pcbQuotation/pcbQuotationEndpoints';
import { pnpEndpoints } from '../pnp/pnpEndpoints';
import { priceEndpoints } from '../price/priceEndpoints';
import { projectEndpoints } from '../project/projectEndpoints';
import { purchaseOrderEndpoints } from '../purchaseOrder/purchaseOrderEndpoints';
import { quotationEndpoints } from '../quotation/quotationEndpoints';
import { quotationTemplateEndpoints } from '../quotationTemplate/quotationTemplateEndpoints';
import { quoteRequestEndpoints } from '../quote-request/quoteRequestEndpoints';
import { quoteRequestTemplateEndpoints } from '../quoteRequestTemplate/quoteRequestTemplateEndpoints';
import { resourceEndpoints } from '../resource/resourceEndpoints';
import { rfqEndpoints } from '../rfq/rfqEndpoints';
import { riskDigestEndpoints } from '../riskDigest/riskDigestEndpoints';
import { internalRoleEndpoints } from '../role/internalRoleEndpoints';
import { solutionEndpoints } from '../solution/solutionEndpoints';
import { sourcingApisEndpoints } from '../sourcingApis/sourcingApisBackendEndpoints';
import { sourcingLineItemEndpoints } from '../sourcingLineItem/sourcingLineItemEndpoints';
import { sourcingScenarioEndpoints } from '../sourcingScenario/sourcingScenarioEndpoints';
import { sourcingTemplateEndpoints } from '../sourcingTemplate/sourcingTemplateEndpoints';
import { supplierEndpoints } from '../supplier/supplierEndpoints';
import { supplierAndStockLocationEndpoints } from '../supplierAndStockLocation/supplierAndStockLocationEndpoints';
import { supplierContactEndpoints } from '../supplierContact/supplierContactEndpoints';
import { supplierTermsEndpoints } from '../supplierTerms';
import { sustainabilityEndpoints } from '../sustainability/sustainabilityEndpoints';
import { tenantEndpoints } from '../tenant/tenantEndpoints';
import { userEndpoints } from '../user/userEndpoints';
import { userBasedEndpoints } from '../userBased/userBasedEndpoints';
/**
 * Required because the inferred type of `endpointRegistry` exceeded the maximum length the compiler could serialize.
 * So, an explicit type annotation was needed.
 */
type InnerActivitiesEndpoints = typeof activitiesEndpoints;
type InnerActivityConfigurationEndpoints = typeof activityConfigurationEndpoints;
type InnerAdditionalServicesEndpoints = typeof additionalServicesEndpoints;
type InnerAlertsEndpoints = typeof alertsEndpoints;
type InnerAssemblyEndpoints = typeof assemblyEndpoints;
type InnerAuthEndpoints = typeof authEndpoints;
type InnerAvlScopeEndpoints = typeof avlScopeEndpoints;
type InnerAzureEndpoints = typeof azureEndpoints;
type InnerBomExportTemplateEndpoints = typeof bomExportTemplateEndpoints;
type InnerBomImporterEndpoints = typeof bomImporterEndpoints;
type InnerBomItemEndpoints = typeof bomItemEndpoints;
type InnerCalculationEndpoints = typeof calculationEndpoints;
type InnerCalculationTemplatesEndpoints = typeof calculationTemplatesEndpoints;
type InnerCommentsEndpoints = typeof commentsEndpoints;
type InnerComponentEndpoints = typeof componentEndpoints;
type InnerContributorEndpoints = typeof contributorEndpoints;
type InnerCostedBomExportTemplateEndpoints = typeof costedBomExportTemplateEndpoints;
type InnerCustomAttributesEndpoints = typeof customAttributesEndpoints;
type InnerCustomerEndpoints = typeof customerEndpoints;
type InnerCustomerPortalSettingsEndpoints = typeof customerPortalSettingsEndpoints;
type InnerCustomPartCategoryEndpoints = typeof customPartCategoryEndpoints;
type InnerDemandEndpoints = typeof demandEndpoints;
type InnerDemandGroupEndpoints = typeof demandGroupEndpoints;
type InnerDemandScenarioEndpoints = typeof demandScenarioEndpoints;
type InnerDesignItemEndpoints = typeof designItemEndpoints;
type InnerDriversEndpoints = typeof driversEndpoints;
type InnerEmailTemplateEndpoints = typeof emailTemplateEndpoints;
type InnerExpenseConfigurationEndpoints = typeof expenseConfigurationEndpoints;
type InnerExpensesEndpoints = typeof expensesEndpoints;
type InnerExportEndpoints = typeof exportEndpoints;
type InnerFilesEndpoints = typeof filesEndpoints;
type InnerFlexibleCalculationEndpoints = typeof flexibleCalculationEndpoints;
type InnerFormulaEndpoints = typeof formulaEndpoints;
type InnerGatewayEndpoints = typeof gatewayEndpoints;
type InnerInternalPartNumberEndpoints = typeof internalPartNumberEndpoints;
type InnerLlmUsageEndpoints = typeof llmUsageEndpoints;
type InnerMachineTokenEndpoints = typeof machineTokenEndpoints;
type InnerManufacturerEndpoints = typeof manufacturerEndpoints;
type InnerManufacturingAssemblyDetailsEndpoints = typeof manufacturingAssemblyDetailsEndpoints;
type InnerManufacturingKvEndpoints = typeof manufacturingKvEndpoints;
type InnerManufacturingScenarioEndpoints = typeof manufacturingScenarioEndpoints;
type InnerManufacturingScenarioTemplatesEndpoints = typeof manufacturingScenarioTemplatesEndpoints;
type InnerManufacturingSourcingCacheEndpoints = typeof manufacturingSourcingCacheEndpoints;
type InnerNegotiationEndpoints = typeof negotiationEndpoints;
type InnerOfferEndpoints = typeof offerEndpoints;
type InnerOfferImportContextEndpoints = typeof offerImportContextEndpoints;
type InnerOrderEndpoints = typeof orderEndpoints;
type InnerOrganizationSettingsEndpoints = typeof organizationSettingsEndpoints;
type InnerPartEndpoints = typeof partEndpoints;
type InnerPcbEndpoints = typeof pcbEndpoints;
type InnerPcbFilesEndpoints = typeof pcbFilesEndpoints;
type InnerPcbPanelPreferenceEndpoints = typeof pcbPanelPreferenceEndpoints;
type InnerPcbQuotationEndpoints = typeof pcbQuotationEndpoints;
type InnerPcbShareEndpoints = typeof pcbShareEndpoints;
type InnerPcbSpecificationTemplateEndpoints = typeof pcbSpecificationTemplateEndpoints;
type InnerPnpEndpoints = typeof pnpEndpoints;
type InnerPriceEndpoints = typeof priceEndpoints;
type InnerProjectEndpoints = typeof projectEndpoints;
type InnerPurchaseOrderEndpoints = typeof purchaseOrderEndpoints;
type InnerQuotationEndpoints = typeof quotationEndpoints;
type InnerQuotationTemplateEndpoints = typeof quotationTemplateEndpoints;
type InnerQuoteRequestEndpoints = typeof quoteRequestEndpoints;
type InnerResourceEndpoints = typeof resourceEndpoints;
type InnerRiskDigestEndpoints = typeof riskDigestEndpoints;
type InnerRfqEndpoints = typeof rfqEndpoints;
type InnerSourcingLineItemEndpoints = typeof sourcingLineItemEndpoints;
type InnerSolutionEndpoints = typeof solutionEndpoints;
type InnerSourcingApisEndpoints = typeof sourcingApisEndpoints;
type InnerSourcingScenarioEndpoints = typeof sourcingScenarioEndpoints;
type InnerSourcingTemplateEndpoints = typeof sourcingTemplateEndpoints;
type InnerSupplierAndStockLocationEndpoints = typeof supplierAndStockLocationEndpoints;
type InnerSupplierContactPersonEndpoints = typeof supplierContactEndpoints;
type InnerSupplierEndpoints = typeof supplierEndpoints;
type InnerSupplierTermsEndpoints = typeof supplierTermsEndpoints;
type InnerSustainabilityEndpoints = typeof sustainabilityEndpoints;
type InnerTenantEndpoints = typeof tenantEndpoints;
type InnerThirdPartyEndpoints = typeof thirdPartyEndpoints;
type InnerUserBasedEndpoints = typeof userBasedEndpoints;
type InnerUserEndpoints = typeof userEndpoints;
type InnerRoleEndpoints = typeof internalRoleEndpoints;
type InnerQuoteRequestTemplateEndpoints = typeof quoteRequestTemplateEndpoints;
type InnerDashboardEndpoints = typeof dashboardEndpoints;
export interface EndpointRegistry
    extends
        InnerAuthEndpoints,
        InnerActivitiesEndpoints,
        InnerActivityConfigurationEndpoints,
        InnerAdditionalServicesEndpoints,
        InnerAlertsEndpoints,
        InnerAssemblyEndpoints,
        InnerAvlScopeEndpoints,
        InnerAzureEndpoints,
        InnerBomExportTemplateEndpoints,
        InnerBomImporterEndpoints,
        InnerBomItemEndpoints,
        InnerCalculationEndpoints,
        InnerCalculationTemplatesEndpoints,
        InnerCommentsEndpoints,
        InnerComponentEndpoints,
        InnerContributorEndpoints,
        InnerCostedBomExportTemplateEndpoints,
        InnerCustomAttributesEndpoints,
        InnerCustomerEndpoints,
        InnerCustomerPortalSettingsEndpoints,
        InnerCustomPartCategoryEndpoints,
        InnerDemandEndpoints,
        InnerDemandGroupEndpoints,
        InnerDemandScenarioEndpoints,
        InnerDesignItemEndpoints,
        InnerDriversEndpoints,
        InnerEmailTemplateEndpoints,
        InnerExpenseConfigurationEndpoints,
        InnerExpensesEndpoints,
        InnerExportEndpoints,
        InnerFilesEndpoints,
        InnerFlexibleCalculationEndpoints,
        InnerFormulaEndpoints,
        InnerGatewayEndpoints,
        InnerInternalPartNumberEndpoints,
        InnerLlmUsageEndpoints,
        InnerMachineTokenEndpoints,
        InnerManufacturerEndpoints,
        InnerManufacturingAssemblyDetailsEndpoints,
        InnerManufacturingKvEndpoints,
        InnerManufacturingScenarioEndpoints,
        InnerManufacturingScenarioTemplatesEndpoints,
        InnerManufacturingSourcingCacheEndpoints,
        InnerNegotiationEndpoints,
        InnerOfferEndpoints,
        InnerOfferImportContextEndpoints,
        InnerOrderEndpoints,
        InnerOrganizationSettingsEndpoints,
        InnerPartEndpoints,
        InnerPcbEndpoints,
        InnerPcbFilesEndpoints,
        InnerPcbPanelPreferenceEndpoints,
        InnerPcbQuotationEndpoints,
        InnerPcbShareEndpoints,
        InnerPcbSpecificationTemplateEndpoints,
        InnerPnpEndpoints,
        InnerPriceEndpoints,
        InnerProjectEndpoints,
        InnerPurchaseOrderEndpoints,
        InnerQuotationEndpoints,
        InnerQuotationTemplateEndpoints,
        InnerQuoteRequestEndpoints,
        InnerResourceEndpoints,
        InnerRiskDigestEndpoints,
        InnerRfqEndpoints,
        InnerRoleEndpoints,
        InnerSourcingLineItemEndpoints,
        InnerSolutionEndpoints,
        InnerSourcingApisEndpoints,
        InnerSourcingScenarioEndpoints,
        InnerSourcingTemplateEndpoints,
        InnerSupplierAndStockLocationEndpoints,
        InnerSupplierContactPersonEndpoints,
        InnerSupplierEndpoints,
        InnerSupplierTermsEndpoints,
        InnerSustainabilityEndpoints,
        InnerTenantEndpoints,
        InnerThirdPartyEndpoints,
        InnerUserBasedEndpoints,
        InnerUserEndpoints,
        InnerQuoteRequestTemplateEndpoints,
        InnerDashboardEndpoints {}

export const endpointRegistry: EndpointRegistry = {
    // Please keep this enumeration sorted alphabetically. Thanks.
    ...activitiesEndpoints,
    ...activityConfigurationEndpoints,
    ...additionalServicesEndpoints,
    ...alertsEndpoints,
    ...assemblyEndpoints,
    ...authEndpoints,
    ...avlScopeEndpoints,
    ...azureEndpoints,
    ...bomExportTemplateEndpoints,
    ...bomImporterEndpoints,
    ...bomItemEndpoints,
    ...calculationEndpoints,
    ...calculationTemplatesEndpoints,
    ...commentsEndpoints,
    ...componentEndpoints,
    ...contributorEndpoints,
    ...costedBomExportTemplateEndpoints,
    ...customAttributesEndpoints,
    ...customerEndpoints,
    ...customerPortalSettingsEndpoints,
    ...customPartCategoryEndpoints,
    ...dashboardEndpoints,
    ...demandEndpoints,
    ...demandGroupEndpoints,
    ...demandScenarioEndpoints,
    ...designItemEndpoints,
    ...driversEndpoints,
    ...emailTemplateEndpoints,
    ...expenseConfigurationEndpoints,
    ...expensesEndpoints,
    ...exportEndpoints,
    ...filesEndpoints,
    ...flexibleCalculationEndpoints,
    ...formulaEndpoints,
    ...gatewayEndpoints,
    ...internalPartNumberEndpoints,
    ...llmUsageEndpoints,
    ...machineTokenEndpoints,
    ...manufacturerEndpoints,
    ...manufacturingAssemblyDetailsEndpoints,
    ...manufacturingKvEndpoints,
    ...manufacturingScenarioEndpoints,
    ...manufacturingScenarioTemplatesEndpoints,
    ...manufacturingSourcingCacheEndpoints,
    ...negotiationEndpoints,
    ...offerEndpoints,
    ...offerImportContextEndpoints,
    ...orderEndpoints,
    ...organizationSettingsEndpoints,
    ...partEndpoints,
    ...pcbEndpoints,
    ...pcbFilesEndpoints,
    ...pcbPanelPreferenceEndpoints,
    ...pcbQuotationEndpoints,
    ...pcbShareEndpoints,
    ...pcbSpecificationTemplateEndpoints,
    ...pnpEndpoints,
    ...priceEndpoints,
    ...projectEndpoints,
    ...purchaseOrderEndpoints,
    ...quotationEndpoints,
    ...quotationTemplateEndpoints,
    ...quoteRequestEndpoints,
    ...resourceEndpoints,
    ...riskDigestEndpoints,
    ...rfqEndpoints,
    ...internalRoleEndpoints,
    ...sourcingLineItemEndpoints,
    ...solutionEndpoints,
    ...sourcingApisEndpoints,
    ...sourcingScenarioEndpoints,
    ...sourcingTemplateEndpoints,
    ...quoteRequestTemplateEndpoints,
    ...supplierAndStockLocationEndpoints,
    ...supplierContactEndpoints,
    ...supplierEndpoints,
    ...supplierTermsEndpoints,
    ...sustainabilityEndpoints,
    ...tenantEndpoints,
    ...thirdPartyEndpoints,
    ...userBasedEndpoints,
    ...userEndpoints,
};
